/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_A5Inputs */

const en_pc_online_faq_a5 = /** @type {(inputs: Pc_Online_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not directly yet. The web build hands you the PDF as a download so you can print it from your system's viewer. The desktop app prints normally.`)
};

const zh_pc_online_faq_a5 = /** @type {(inputs: Pc_Online_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂时不能直接打印。网页版会把 PDF 以下载的形式交给你，你可以用系统自带的查看器打印。桌面版可以正常打印。`)
};

/**
* | output |
* | --- |
* | "Not directly yet. The web build hands you the PDF as a download so you can print it from your system's viewer. The desktop app prints normally." |
*
* @param {Pc_Online_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_a5 = /** @type {((inputs?: Pc_Online_Faq_A5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_A5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_a5(inputs)
	return zh_pc_online_faq_a5(inputs)
});
export { pc_online_faq_a5 as "pc.online.faq.a5" }